import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import MaterialModal from "../MaterialModal";
import withModal from "../withModal";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { IAppState } from "../../../types/stores";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl/FormControl";
import Icon from "@material-ui/core/Icon";

const copyFeaturesProps = {
    // Injected from Redux
    modalProps: PropTypes.shape({
        continue: PropTypes.func.isRequired,
    }).isRequired,
    isOpen: PropTypes.bool.isRequired,
};

type CopyFeaturesModalProps = PropTypes.InferProps<typeof copyFeaturesProps>;

const CopyFeaturesModal: React.FC<CopyFeaturesModalProps> = ({ modalProps, isOpen }: CopyFeaturesModalProps) => {
    const dispatch = useDispatch();

    const hide = () => dispatch(hideModal("COPY_FEATURES"));
    const [selectedCompany, setSelectedCompany] = useState(0);
    const [selectedOption, setSelectedOption] = useState(0);
    const companyId = useSelector<IAppState, number>(state => state.session.companyId!);
    const companies = useSelector<IAppState, Array<any>>(state => state.session.companies).filter(
        x => x.CompanyID != companyId
    );

    const continueRequest = () => {
        modalProps.continue(selectedCompany, selectedOption);
        hide();
    };

    const handleSelectCompany = e => {
        setSelectedCompany(e.target.value);
    };

    const handleSelectOption = e => {
        setSelectedOption(e.target.value);
    };

    return (
        <MaterialModal
            title="Copy Features"
            isOpen={isOpen}
            onClose={hide}
            id="copy-features"
            maxWidth="sm"
            primaryButtonText="Continue"
            onPrimaryButtonRequest={() => continueRequest()}
        >
            <div className="row" style={{ marginBottom: "25px" }}>
                <div className="col-xs-6">
                    <FormControl fullWidth>
                        <InputLabel id="company-select">Destination company for features</InputLabel>
                        <Select
                            id="company-select"
                            label="Destination company for features"
                            value={selectedCompany}
                            onChange={handleSelectCompany}
                        >
                            {companies.map(company => (
                                <MenuItem
                                    key={company.CompanyID}
                                    className="company-select-option"
                                    value={company.CompanyID}
                                >
                                    {company.CompanyName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
            </div>
            <div className="row" style={{ marginBottom: "25px" }}>
                <div className="col-xs-6">
                    <FormControl fullWidth>
                        <InputLabel id="option-select">Type of features copy</InputLabel>
                        <Select id="option-select" label="Type of features copy" onChange={handleSelectOption}>
                            <MenuItem key={0} value={0}>
                                Replace
                            </MenuItem>
                            <MenuItem key={1} value={1}>
                                Merge
                            </MenuItem>
                        </Select>
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <p>
                        <Icon
                            className="text-warning"
                            style={{ marginRight: "10px", position: "relative", top: "5px" }}
                            fontSize="large"
                        >
                            warning
                        </Icon>
                        How it works?
                    </p>
                    <p>
                        <b>Replace</b> - Wipe the company features and replace the selection with those in the copied
                        list
                    </p>
                    <p>
                        <b>Merge</b> - Turn on additional features in the company that are disabled but are in the
                        copied list
                    </p>
                </div>
            </div>
        </MaterialModal>
    );
};

export default withModal(CopyFeaturesModal, "COPY_FEATURES");
